import { formValidators } from '../../../utils/form/validators';

export const formFieldValidators = {
  firstName: [
    formValidators.required('Please enter a first name'),
    formValidators.alpha('Please enter an alphabetical value'),
  ],
  lastName: [
    formValidators.required('Please enter a last name'),
    formValidators.alpha('Please enter an alphabetical value'),
  ],
  email: [
    formValidators.required('Please enter an email address'),
    formValidators.email('Please enter a valid email address'),
  ],
  phoneNumber: [
    formValidators.required('Please enter a phone number'),
    formValidators.phone('Please enter a valid phone number'),
  ],
  phoneDiallingCode: [formValidators.required('Please select a dialing code')],
  addressLine1: [formValidators.required('Please enter an address')],
  city: [
    formValidators.required('Please enter a city'),
    formValidators.alpha('Please enter a valid City'),
  ],
  postalCode: [
    formValidators.required('Please enter a ZIP code'),
    formValidators.usZipCode('Please enter a valid Zip Code'),
  ],
  regionOrStateCode: [formValidators.required('Please select a state')],

  merchandiseLocationLine1: [formValidators.required('Please enter an address')],
  merchandiseLocationCity: [
    formValidators.required('Please enter a city'),
    formValidators.noDigits('Please enter a valid City'),
  ],
  merchandiseLocationPostalCode: [
    formValidators.required('Please enter a ZIP code'),
    formValidators.usZipCode('Please enter a valid Zip Code'),
  ],
  merchandiseLocationRegionOrStateCode: [formValidators.required('Please select a state')],
};
